const giftVariantId = 41399617224841;
const qualifyingTags = ['BRAND= Avene','BRAND=Av�ne'];
const requiredQty = 2;

// Fetch product tags for a given handle
async function getProductTags(handle) {
    try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
        const product = await res.json();
        console.log(`Product tags for ${product.title}:`, product.tags);
        return product.tags || [];
    } catch (err) {
        console.error('Error fetching product tags:', err);
        return [];
    }
}

// Add free gift
async function addGift() {
    console.log('Adding free gift...');
    const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: giftVariantId, quantity: 1 })
    });
    const data = await res.json();
    console.log('Add gift response:', data);
    window.location.reload();
}

// Remove free gift
async function removeGift(lineId) {
    console.log('Removing free gift...');
    const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineId, quantity: 0 })
    });
    const data = await res.json();
    console.log('Remove gift response:', data);
}

// Main function to handle free gift logic
async function handleFreeGift(cart) {
    // Fetch all product tags in parallel
    const tagPromises = cart.items.map(item => getProductTags(item.handle));
    const allTags = await Promise.all(tagPromises);

    // Count eligible quantity
    let eligibleQty = 0;
    allTags.forEach((tags, index) => {
        const hasEligibleTag = tags.some(tag => qualifyingTags.includes(tag));
        if (hasEligibleTag) {
            eligibleQty += cart.items[index].quantity;
        }
    });
    console.log('Total eligible quantity:', eligibleQty);

    // Check if gift is already in cart
    const giftItem = cart.items.find(item => item.variant_id === giftVariantId);

    if (eligibleQty >= requiredQty && !giftItem) {
        await addGift();
        console.log('Free gift added');
    } else if (eligibleQty < requiredQty && giftItem) {
        //await removeGift(giftItem.key);
        console.log('Free gift removed');
    } else {
        console.log('No action required');
    }
}

// Run on page load
document.addEventListener('DOMContentLoaded', async () => {
    const cart = await fetch('/cart.js').then(res => res.json());
    await handleFreeGift(cart);
});

// Optional: Run whenever cart updates (depends on your theme triggering this event)
document.addEventListener('cart:updated', async (event) => {
    await handleFreeGift(event.detail.cart);
});
// On cart page, keep checking for changes
if (window.location.pathname === '/cart') {
    let lastCartState = null;

    async function checkCartChanges() {
        const cart = await fetch('/cart.js').then(res => res.json());
        const currentCartHash = JSON.stringify(cart.items.map(i => ({ id: i.variant_id, qty: i.quantity })));

        if (currentCartHash !== lastCartState) {

            lastCartState = currentCartHash;
            await handleFreeGift(cart);
        }

        setTimeout(checkCartChanges, 500); // check every 0.5 seconds
    }


    // Start polling
    checkCartChanges();
}